import { emptyDisplayValue } from 'constants/common';
import {
    ContentRoleLevel,
    Grade,
    SoftSkillRoleLevelContent,
} from 'generated/graphql';

export const GradeLabelMap = {
    [Grade.APlus]: 'A +',
    [Grade.A]: 'A',
    [Grade.B]: 'B',
    [Grade.C]: 'C',
    [Grade.D]: 'D',
    [Grade.E]: 'E',
};

export const RoleLevelLabelMap = {
    [ContentRoleLevel.Apprentice]: 'Apprentice',
    [ContentRoleLevel.IndividualContributor]: 'Individual contributor',
    [ContentRoleLevel.Leader]: 'Leader',
    [ContentRoleLevel.Manager]: 'Manager',
    [ContentRoleLevel.ManagerOfManagers]: 'Manager of managers',
    [ContentRoleLevel.TechnicalExpert]: 'Technical expert',
};

export const GRADES = [
    { label: GradeLabelMap[Grade.APlus], value: Grade.APlus },
    { label: GradeLabelMap[Grade.A], value: Grade.A },
    { label: GradeLabelMap[Grade.B], value: Grade.B },
    { label: GradeLabelMap[Grade.C], value: Grade.C },
    { label: GradeLabelMap[Grade.D], value: Grade.D },
    { label: GradeLabelMap[Grade.E], value: Grade.E },
];

export const ROLE_LEVELS = [
    {
        label: RoleLevelLabelMap[ContentRoleLevel.Apprentice],
        value: ContentRoleLevel.Apprentice,
    },
    {
        label: RoleLevelLabelMap[ContentRoleLevel.IndividualContributor],
        value: ContentRoleLevel.IndividualContributor,
    },
    {
        label: RoleLevelLabelMap[ContentRoleLevel.Leader],
        value: ContentRoleLevel.Leader,
    },
    {
        label: RoleLevelLabelMap[ContentRoleLevel.Manager],
        value: ContentRoleLevel.Manager,
    },
    {
        label: RoleLevelLabelMap[ContentRoleLevel.ManagerOfManagers],
        value: ContentRoleLevel.ManagerOfManagers,
    },
    {
        label: RoleLevelLabelMap[ContentRoleLevel.TechnicalExpert],
        value: ContentRoleLevel.TechnicalExpert,
    },
];

export const IMMUTABLE_FIELDS = ['Grade', 'Role level'];

export const getInitialValues = (
    content: { label: string; value?: string | null; key: string }[]
) => {
    return {
        description: content.find(item => item.key === 'description')?.value,
        hiringManagerContent: content.find(
            item => item.key === 'hiringManagerContent'
        )?.value,
        candidateContent: content.find(item => item.key === 'candidateContent')
            ?.value,
        internalCandidateContent: content.find(
            item => item.key === 'internalCandidateContent'
        )?.value,
    };
};

export const getContent = (content: SoftSkillRoleLevelContent) => {
    return [
        {
            label: 'Grade',
            value: GradeLabelMap[content.grade] || emptyDisplayValue,
            key: 'grade',
        },
        {
            label: 'Role level',
            value:
                RoleLevelLabelMap[content.roleLevel as ContentRoleLevel] || emptyDisplayValue,
            key: 'roleLevel',
        },
        {
            label: 'Description',
            value: content.description,
            key: 'description',
        },
        {
            label: 'Candidate feedback',
            value: content.candidateContent,
            key: 'candidateContent',
        },
        {
            label: 'Hiring manager feedback',
            value: content.hiringManagerContent,
            key: 'hiringManagerContent',
        },
        {
            label: 'Development feedback',
            value: content.internalCandidateContent,
            key: 'internalCandidateContent',
        },
    ];
};